<script>
    import {
        addIcon,
        exportIcon,
        uploadIcon,
    } from "../../../Utils/utilConstants.svelte";
    import { isObjectEmpty } from "../../../Utils/utilFunctions.svelte";

    import BillingRules from "../../BillingRules/BillingRules.svelte";

    import Presets from "../../Presets/Presets.svelte";

    export let params = {};
    export let doctorDetails = {};
    export let reload = () => {};

    let billingRuleRef, presetRef;

    $: billingRuleBntOptions = billingRuleRef
        ? [
              {
                  iFont: exportIcon,
                  hasTooltip: true,
                  tooltip: "Export Billing Rules",
                  btnText: "Export",
                  iconName: "exportIcon",
                  iconFunction: () => billingRuleRef?.exportBillingRule(),
              },
              {
                  iFont: uploadIcon,
                  hasTooltip: true,
                  tooltip: "Import Billing Rule",
                  btnText: "Import",
                  iconName: "uploadIcon",
                  iconFunction: () => billingRuleRef?.startUploadBillingRule(),
              },
              {
                  iFont: addIcon,
                  hasTooltip: true,
                  tooltip: "Create Billing Rule",
                  btnText: "Create",
                  iconName: "createIcon",
                  iconFunction: () => createBillingRule(),
              },
          ]
        : [];

    $: presetBtnOptions = presetRef
        ? [
              {
                  iFont: exportIcon,
                  hasTooltip: true,
                  tooltip: "Export Presets",
                  btnText: "Export",
                  iconName: "exportIcon",
                  iconFunction: () => presetRef?.exportPresets(),
              },
              {
                  iFont: uploadIcon,
                  hasTooltip: true,
                  tooltip: "Import Preset",
                  btnText: "Import",
                  iconName: "uploadIcon",
                  iconFunction: () => presetRef?.startUploadPreset(),
              },
              {
                  iFont: addIcon,
                  hasTooltip: true,
                  tooltip: "Create Preset",
                  btnText: "Create",
                  iconName: "createIcon",
                  iconFunction: () => createPreset(),
              },
          ]
        : [];

    const createBillingRule = () => billingRuleRef.openModifyBillingRuleModal();

    const createPreset = () => presetRef.openModifyPresetModal();

    const reloadBillingRules = (newDoctorDetails = {}) => {
        if (!newDoctorDetails || isObjectEmpty(newDoctorDetails)) return;

        doctorDetails = newDoctorDetails;

        billingRuleRef.reloadBillingRules();
    };
</script>

<div class="relative flex-1">
    <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 m-4">
        <BillingRules
            bind:this={billingRuleRef}
            bind:doctorDetails
            {params}
            inCardMode
            cardModeConfig={{
                title: "Billing Rules",
                btnOptions: billingRuleBntOptions,
            }}
        />

        <Presets
            bind:this={presetRef}
            bind:doctorDetails
            {params}
            inCardMode
            cardModeConfig={{
                title: "Presets",
                btnOptions: presetBtnOptions,
            }}
            {reloadBillingRules}
        />
    </div>
</div>
